export async function getRecaptchaToken(): Promise<string | undefined> {
	const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
	if (!siteKey) return undefined;
	const grecaptcha = window.grecaptcha;
	if (!grecaptcha) return undefined;
	return new Promise<string>((resolve, reject) => {
		grecaptcha.ready(() => {
			grecaptcha
				.execute(siteKey, { action: "submit" })
				.then(resolve)
				.catch(reject);
		});
	});
}
